// extracted by mini-css-extract-plugin
module.exports = {"color":"MultiText_color__JA3TJ","blockquote":"MultiText_blockquote__dF0pX"};